<div class="container">
    <div (click)="bellClick()" class="icon-container p-mr-4 p-ml-2 prs-notifications-dropdown-trigger" tabindex="0">
        <i class="pi pi-bell p-p-2 icon"></i>
        <div *ngIf="notificationCount > 0" class="notification-count" [innerText]="notificationCount < 10 ? notificationCount : '9+'"></div>
    </div>
</div>
<div *ngIf="notificationsActive" class="dropdown-container prs-notifications-dropdown">
    <ds-panel [showHeader]="false" [class.notifications-content]="notificationsLoading">
        <ng-container *ngIf="!notificationsLoading">
            <ng-container *ngIf="notifications.length">
                <ng-container *ngFor="let notification of notifications">
                    <app-notification-block [internalApp]="internalApp" [notification]="notification"></app-notification-block>
                </ng-container>
                <div *ngIf="!internalApp" (click)="showAllNotifications()" class="dropdown-action p-small" tabindex="0">
                    Zobacz wszystkie
                </div>
                <div *ngIf="internalApp" (click)="clearNotifications()" class="dropdown-action p-small" tabindex="0">
                    Wyczyść wszystkie
                </div>
            </ng-container>
            <ng-container *ngIf="!notifications.length">
                <div class="p-p-6 notifications-empty">Brak nowych powiadomień</div>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="notificationsLoading">
            <ds-loader></ds-loader>
        </ng-container>
    </ds-panel>
</div>
